import { render, staticRenderFns } from "./onboarding-index.vue?vue&type=template&id=147000d3"
import script from "./onboarding-index.vue?vue&type=script&lang=js"
export * from "./onboarding-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports